/* eslint-disable react/jsx-props-no-spreading */
const Title = ({ level, ...props }) => {
  const Tag = ['h1', 'h2', 'h3', 'h4'][level - 1] || 'p';
  return <Tag {...props} />;
};

export default Title;
